export const PROSPECT_VALUE_COOKIE_NAME = 'nu__prospect_value';
export const AUTHORIZATION_REQUEST_COOKIE_NAME = 'nu__authorization_request';
